import { render } from "./SmallButton.vue?vue&type=template&id=0fd52f22&ts=true"
import script from "./SmallButton.vue?vue&type=script&lang=ts"
export * from "./SmallButton.vue?vue&type=script&lang=ts"

import "./SmallButton.vue?vue&type=style&index=0&id=0fd52f22&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__